// {year: 'numeric', month: 'long', day: 'numeric' }; e.g. => '20. december 2010', if locale = 'da'

import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

/**
 * Returns a formatted, human readable date string, given a unix timestamp
 * input (seconds since 00:00:00 UTC on 1 January 1970) and a locale.
 *
 * You can use `options` parameter to fine tune the output.
 *
 * @param seconds
 * @param locale a locale, 'en' is the default.
 * @param options The same options as for js Date.toLocaleString().
 */
export const getHumanDateFromUnixTimestamp = (
  seconds: number,
  locale = 'en',
  options?: DateTimeFormatOptions,
): string => {
  const dateObj = new Date(seconds * 1000)
  return dateObj.toLocaleDateString(locale, options)
}
